import { PrimaryFontColorLanding } from "assets/jss/material-kit-pro-react";
import { primaryColorLanding } from "assets/jss/material-kit-pro-react";
import { container } from "assets/jss/material-kit-pro-react";

const style = (theme) => ({
  container: {
    ...container,
    zIndex: "2",
    position: "relative",
    backgroundColor: primaryColorLanding,
    "& h1, & h2, & h4, & h6": {
      color: PrimaryFontColorLanding,
    },
    "@media (min-width: 1200px)": {
      maxWidth: "1800px",
    },
    "@media (min-width: 992px)": {
    maxWidth: "1200px",
  },
  },
});

export default style;
